// extracted by mini-css-extract-plugin
export default {"embedRoot":"PowerBIEmbed_embedRoot__6255O","reportContainer":"PowerBIEmbed_reportContainer__CltkJ","overlay":"PowerBIEmbed_overlay__sakrt","error":"PowerBIEmbed_error__cMCUP"};